class ReviewSlider extends HTMLElement {
    constructor() {
        super();
        this.slider = this;
        this.initSlider();
    }

    initSlider() {
        new Swiper(this.slider, {
            slidesPerView: 1.3,
            grabCursor: true,
            spaceBetween: 10,
            pagination: {
                el: this.querySelector('.swiper-pagination'),
                clickable: true,
            },
            navigation: {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                1220: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
            },

        });
    }
}

customElements.define('review-slider', ReviewSlider);


